import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddModelModal from "./components/AddModelModal";
import ModelTable from "./components/ModelTable";
import {
  selectManufacturerModelsList,
  selectManufacturerModelsLoading,
} from "./redux/selector";
import { manufacturerModelSaga } from "./redux/saga";
import {
  manufacturerModelActions,
  reducer,
  sliceKey,
} from "./redux/slice";
import { useStyles } from "./styles";

const ManufacturerModel = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: manufacturerModelSaga,
  });

  const rows = useSelector(selectManufacturerModelsList);
  const loading = useSelector(selectManufacturerModelsLoading);

  useEffect(() => {
    dispatch(manufacturerModelActions.getManufacturerModelsList());
  }, [dispatch]);

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb
              title={t("SIDEBAR.MODEL_PER_MANUFACTURER")}
              iconPosition="end"
            />
            <ActionBar
              onAddClick={() => dispatch(manufacturerModelActions.openAddModal())}
            />
            <ModelTable rows={rows} loading={loading} />
          </Box>
        </Box>
      <AddModelModal />
    </Box>
  );
};

export default ManufacturerModel;
